// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root___lkeD","errors":"Errors_errors__3ueWv"};